// extracted by mini-css-extract-plugin
module.exports = {"selected_cv":"applyjobmodal-module__selected_cv___3IPJ_"};